import {
  Container,
  Box,
  Paper,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import {
  MusicNote,
  PlaylistPlay,
  LibraryMusic,
  FindInPage,
  FileUpload,
  Quiz,
  Analytics,
  SmartToy,
  Casino,
  CasinoOutlined,
  Settings as SettingsIcon,
  Theaters as ShowTimeIcon,
  ConfirmationNumber,
  VolumeUp,
  EmojiEvents,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import Header from "./Header";

const AdminHomePage = () => {

  const linkStyle = {
    textDecoration: "none",
    color: "inherit",
  };

  // Songq category items (first 6)
  const songqItems = [
    {
      title: "Songs Requests",
      path: "/AdminRequestCompact",
      icon: <MusicNote sx={{ fontSize: 32 }} />,
      color: "#FF6B6B",
    },
    {
      title: "Playlists",
      path: "/allplaylistscreen",
      icon: <PlaylistPlay sx={{ fontSize: 32 }} />,
      color: "#4ECDC4",
    },
    {
      title: "Songs",
      path: "/allsongscreen",
      icon: <LibraryMusic sx={{ fontSize: 32 }} />,
      color: "#45B7D1",
    },
    {
      title: "Dups Songs",
      path: "/DuplicateSongs",
      icon: <LibraryMusic sx={{ fontSize: 32 }} />,
      color: "#FFA07A",
    },
    {
      title: "Look Ups",
      path: "/lookuptabs",
      icon: <FindInPage sx={{ fontSize: 32 }} />,
      color: "#98D8C8",
    },
    {
      title: "Import Songs",
      path: "/ImportedSongs",
      icon: <FileUpload sx={{ fontSize: 32 }} />,
      color: "#F7DC6F",
    },
    {
      title: "Crowd Requests",
      path: "/RequestedSongs",
      icon: <LibraryMusic sx={{ fontSize: 32 }} />,
      color: "#E67E22",
    },
  ];

  // Quiz category items
  const quizItems = [
    {
      title: "Quiz Lookups",
      path: "/AdminLookup",
      icon: <FindInPage sx={{ fontSize: 32 }} />,
      color: "#9B59B6",
    },
    {
      title: "Quiz",
      path: "/AdminQuiz",
      icon: <Quiz sx={{ fontSize: 32 }} />,
      color: "#E74C3C",
    },
    {
      title: "Quiz Import",
      path: "/AdminQuizImport",
      icon: <FileUpload sx={{ fontSize: 32 }} />,
      color: "#3498DB",
    },
    {
      title: "Quiz Analytics",
      path: "/analytics",
      icon: <Analytics sx={{ fontSize: 32 }} />,
      color: "#1ABC9C",
    },
    {
      title: "AI QGen",
      path: "/AdminAiQGen",
      icon: <SmartToy sx={{ fontSize: 32 }} />,
      color: "#00C9A7",
    },
  ];

  // Games category items
  const gamesItems = [
    {
      title: "Higher or Lower",
      path: "/AdminHigherOrLower",
      icon: <Casino sx={{ fontSize: 32 }} />,
      color: "#FF6B9D",
    },
    {
      title: "Spinning Wheel",
      path: "/AdminSpinningWheel",
      icon: <CasinoOutlined sx={{ fontSize: 32 }} />,
      color: "#9B59B6",
    },
    {
      title: "Buzzer",
      path: "/AdminBuzzer",
      icon: <Casino sx={{ fontSize: 32 }} />,
      color: "#F39C12",
    },
    {
      title: "Beer Millionaire",
      path: "/AdminBeerillioner",
      icon: <Casino sx={{ fontSize: 32 }} />,
      color: "#FFD700",
    },
  ];

  const mymItems = [
    {
      title: "Configuration",
      path: "/AdminConfig",
      icon: <SettingsIcon sx={{ fontSize: 32 }} />,
      color: "#00FFFF",
    },
    {
      title: "Show Time",
      path: "/AdminShowTime",
      icon: <ShowTimeIcon sx={{ fontSize: 32 }} />,
      color: "#FF6B9D",
    },
    {
      title: "Spectator View",
      path: "/AdminSpectator",
      icon: <ShowTimeIcon sx={{ fontSize: 32 }} />,
      color: "#E040FB",
    },
    {
      title: "Sound System",
      path: "/AdminSounds",
      icon: <VolumeUp sx={{ fontSize: 32 }} />,
      color: "#1DB954",
    },
    {
      title: "Sound Palette",
      path: "/AdminSoundPalette",
      icon: <VolumeUp sx={{ fontSize: 32 }} />,
      color: "#E040FB",
    },
    {
      title: "Prize Palette",
      path: "/AdminPrizePalette",
      icon: <EmojiEvents sx={{ fontSize: 32 }} />,
      color: "#FFD54F",
    },
  ]

  const ticketItems = [
    {
      title: "Ticket Dashboard",
      path: "/AdminTicketDashboard",
      icon: <ConfirmationNumber sx={{ fontSize: 32 }} />,
      color: "#667eea",
    },
  ];

  return (
    <>
      <Header />
      <Container
        maxWidth="lg"
        sx={{
          mt: 2,
          mb: 2,
          px: { xs: 1.5, sm: 2 },
        }}
      >
        {/* Songq Category Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: "#fff",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
            }}
          >
            Songq - Config
          </Typography>
          <Grid container spacing={2}>
            {songqItems.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Link to={item.path} style={linkStyle}>
                  <Paper
                    elevation={0}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      p: 0.5,
                      backgroundColor: "#1E1E1E",
                      border: "1px solid #333",
                      borderRadius: "12px",
                      height: "100%",
                      minHeight: { xs: 50, sm: 60 },
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      cursor: "pointer",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        borderColor: item.color,
                        backgroundColor: "#252525",
                        boxShadow: `0 8px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px ${item.color}40`,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 20,
                        height: 20,
                        borderRadius: "12px",
                        backgroundColor: `${item.color}20`,
                        color: item.color,
                        mx: 1,
                        flexShrink: 0,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "#fff",
                        fontSize: { xs: "0.95rem", sm: "1rem", md: "1rem" },
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Divider sx={{ my: 3, borderColor: "#333" }} />

        {/* MYM Category Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: "#fff",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
            }}
          >
            MYM - Config 
          </Typography>
          <Grid container spacing={2}>
            {mymItems.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Link to={item.path} style={linkStyle}>
                  <Paper
                    elevation={0}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      p: 0.5,
                      backgroundColor: "#1E1E1E",
                      border: "1px solid #333",
                      borderRadius: "12px",
                      height: "100%",
                      minHeight: { xs: 50, sm: 60 },
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      cursor: "pointer",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        borderColor: item.color,
                        backgroundColor: "#252525",
                        boxShadow: `0 8px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px ${item.color}40`,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 20,
                        height: 20,
                        borderRadius: "12px",
                        backgroundColor: `${item.color}20`,
                        color: item.color,
                        mx: 1,
                        flexShrink: 0,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "#fff",
                        fontSize: { xs: "0.95rem", sm: "1rem", md: "1rem" },
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Divider sx={{ my: 3, borderColor: "#333" }} />

        {/* Quiz Category Section */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: "#fff",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
            }}
          >
            Quiz
          </Typography>
          <Grid container spacing={2}>
            {quizItems.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Link to={item.path} style={linkStyle}>
                  <Paper
                    elevation={0}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      p: 0.5,
                      backgroundColor: "#1E1E1E",
                      border: "1px solid #333",
                      borderRadius: "12px",
                      height: "100%",
                      minHeight: { xs: 50, sm: 60 },
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      cursor: "pointer",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        borderColor: item.color,
                        backgroundColor: "#252525",
                        boxShadow: `0 8px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px ${item.color}40`,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 20,
                        height: 20,
                        borderRadius: "12px",
                        backgroundColor: `${item.color}20`,
                        color: item.color,
                        mx: 1,
                        flexShrink: 0,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "#fff",
                        fontSize: { xs: "0.95rem", sm: "1rem", md: "1rem" },
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Divider sx={{ my: 3, borderColor: "#333" }} />

        {/* Games Category Section */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: "#fff",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
            }}
          >
            Games
          </Typography>
          <Grid container spacing={2}>
            {gamesItems.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Link to={item.path} style={linkStyle}>
                  <Paper
                    elevation={0}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      p: 0.5,
                      backgroundColor: "#1E1E1E",
                      border: "1px solid #333",
                      borderRadius: "12px",
                      height: "100%",
                      minHeight: { xs: 50, sm: 60 },
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      cursor: "pointer",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        borderColor: item.color,
                        backgroundColor: "#252525",
                        boxShadow: `0 8px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px ${item.color}40`,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 48,
                        height: 48,
                        borderRadius: "8px",
                        bgcolor: `${item.color}20`,
                        mr: 1.5,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: "#fff",
                        fontSize: { xs: "0.95rem", sm: "1rem", md: "1rem" },
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Divider sx={{ my: 3, borderColor: "#333" }} />

        {/* Tickets Category Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: "#fff",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
            }}
          >
            Tickets
          </Typography>
          <Grid container spacing={2}>
            {ticketItems.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Link to={item.path} style={linkStyle}>
                  <Paper
                    elevation={0}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      p: 0.5,
                      backgroundColor: "#1E1E1E",
                      border: "1px solid #333",
                      borderRadius: "12px",
                      height: "100%",
                      minHeight: { xs: 50, sm: 60 },
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      cursor: "pointer",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        borderColor: item.color,
                        backgroundColor: "#252525",
                        boxShadow: `0 8px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px ${item.color}40`,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 20,
                        height: 20,
                        borderRadius: "12px",
                        backgroundColor: `${item.color}20`,
                        color: item.color,
                        mx: 1,
                        flexShrink: 0,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "#fff",
                        fontSize: { xs: "0.95rem", sm: "1rem", md: "1rem" },
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default AdminHomePage;